import { useEffect, useState } from 'react';
import { ChecklistType } from '../../../../service/Checklists';
import AttToken from '../../../../helpers/attToken';
import ServiceTypes, { types } from '../../../../service/ServiceTypes';
import { useTranslation } from 'react-i18next';
import { Autocomplete, Chip, Skeleton, Stack, TextField, Typography } from '@mui/material';
import { trackEventMatomo } from '../../../../helpers/matomo';
import QueryFn from '../../../../helpers/QueryFn';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';


type props = {
  setEditModal: Function,
  form: ChecklistType
};

type mandatorySub = 'naoConforme' | 'confome' | 'sempre' | 'nunca';

export type ticketConfigType = {
  serviceTypes: string[],
  limit: number,
  mandatory: string | boolean,
};


function useForceUpdate() {
  const [value, setState] = useState(true);
  return () => setState(!value);
}

const serviceTypeService = new ServiceTypes();
const queryFn = new QueryFn();

export default function FormChamadosConfig({ form }: props) {

  const { t } = useTranslation('translation');

  const [serviceTypesForm, setServiceTypesForm] = useState<string[]>([]);
  const [serviceTypesSub, setServiceTypesSub] = useState<string[]>([]);
  const [limitForm, setLimitForm] = useState<number>(0);
  const [limitSub, setLimitSub] = useState<number>(0);
  const [mandatoryForm, setMandatoryForm] = useState<boolean>(false);
  const [mandatorySub, setMandatorySub] = useState<string>('naoConforme');
  const [selectedSub, setSelectedSub] = useState('');

  const getAllServices = async () => {
    try {
      const token = await AttToken();
      if (token) {
        const body = { ...token, empresa: token.userEmpresa };
        const result = await serviceTypeService.getAllServices(body);
        return result;
      }
    } catch (err) {

    }
  };
  const handleForceupdateMethod = useForceUpdate();

  const services = queryFn.useFetch('GET_SERVICES', getAllServices);

  useEffect(() => {
    if (form.ticketConfig) {
      setServiceTypesForm(form.ticketConfig.serviceTypes);
      setLimitForm(form.ticketConfig.limit);
      setMandatoryForm(form.ticketConfig.mandatory as boolean);
    }
  }, []);

  useEffect(() => {
    if (form.ticketConfig) {
      setServiceTypesForm(form.ticketConfig.serviceTypes);
      setLimitForm(form.ticketConfig.limit);
      setMandatoryForm(form.ticketConfig.mandatory as boolean);
    }
  }, []);

  useEffect(() => {
    if (selectedSub) {
      const subitem = form.itens[Number(selectedSub.slice(0, -2))]?.subitens?.[Number(selectedSub.slice(-1))];
      console.log(subitem);
      if (subitem) {
        const ticketConfig = {
          mandatory: mandatorySub as string,
          serviceTypes: serviceTypesSub,
          limit: limitSub
        };
        subitem.ticketConfig = ticketConfig;
      }
    }
  }, [limitSub, mandatorySub, serviceTypesSub]);

  const getSubItemFilled = (value: string) => {
    if (value) {
      const subitem = form?.itens[Number(value.slice(0, -2))]?.subitens[Number(value.slice(-1))];
      if (subitem) {
        if (subitem.ticketConfig) {
          setMandatorySub(subitem.ticketConfig?.mandatory as string);
          setLimitSub(subitem.ticketConfig.limit);
          setServiceTypesSub(subitem.ticketConfig.serviceTypes);
        } else {
          setMandatorySub('naoConforme');
          setLimitSub(0);
          setServiceTypesSub([]);
        }
      }
    }
  };

  function subitemType(value: string) {
    if (value) {
      if (value) {
        const sub = form?.itens[Number(value.slice(0, -2))]?.subitens[Number(value.slice(-1))];
        if (sub?.tipo === "avaliacao") {
          return false;
        }
        return true;
      }
    }
  }

  useEffect(() => {
    if (form) {
      form.ticketConfig = {
        limit: limitForm,
        mandatory: mandatoryForm,
        serviceTypes: serviceTypesForm
      };
    }
  }, [serviceTypesForm, limitForm, mandatoryForm]);

  return (
    <>
      {services.isLoading
        ? <Stack
          width='100%'
          direction="column"
          justifyContent="center"
          alignItems="center"
          spacing={2}
        >
          <Skeleton variant='rounded' height={30} width={300} />
          <Stack
            width={'100%'}
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            spacing={1}
          >
            <Skeleton variant='rounded' height={40} width={300} />
            <Skeleton variant='rounded' height={40} width={100} />
            <Skeleton variant='rounded' height={40} width={80} />
          </Stack>
          <Skeleton variant='rounded' height={40} width={300} />
          <Skeleton variant='rounded' height={40} width='100%' />
        </Stack>
        : <Stack
          width='100%'
          direction="column"
          justifyContent="center"
          alignItems="center"
          spacing={2}
        >
          <Typography>
            {t('formDetails.configChamados.ChamadosPor')}
          </Typography>
          <Stack
            width={'100%'}
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            spacing={1}
          >
            <Autocomplete
              fullWidth
              id="tags-standard"
              size='small'
              multiple
              onClick={() => trackEventMatomo('modal config form', 'click', 'select', 'seleciona tipo de serviço')}
              value={serviceTypesForm?.map((ele) => (
                {
                  value: ele,
                  label: services.data?.find((elem: types) => elem.tipoId === ele)?.nome
                }
              )) || []}
              isOptionEqualToValue={(option, value) => option.value === value.value}
              filterSelectedOptions
              disableClearable
              options={
                services.data?.sort((a: types, b: types) => {
                  return a.nome.toLowerCase() > b.nome.toLowerCase() ? 1 : - 1;
                })
                  ?.map((ele: types) => ({
                    label: ele.nome,
                    value: ele.tipoId,
                  })) || []}
              renderTags={(tagValue, getTagProps) => {
                return tagValue.map((option, index) => (
                  <Chip style={{ marginTop: '12px' }} {...getTagProps({ index })} label={option.label} />
                ));
              }}
              onChange={(event: any, newValue: { label: string, value: string }[] | null, reason: any, details: any) => {
                const value = details?.option.value;
                if (serviceTypesForm?.includes(value)) {
                  setServiceTypesForm(prev => prev ? prev.filter(el => el !== value) : []);
                } else {
                  setServiceTypesForm((prev) => prev ? [...prev, value] : [value]);
                }
              }}
              renderOption={(props, option, { selected }) => (
                <li {...props} key={option.value}>
                  <span>{option.label}</span>
                </li>)}
              renderInput={(params) => <TextField {...params} InputLabelProps={{ style: { fontSize: '0.7em' } }} label={t('formDetails.configChamados.SelecioneOTipoformulario')} />}
            />
            <TextField
              size='small'
              onClick={() => trackEventMatomo('modal config form', 'click', 'input', 'adiciona texto')}
              InputLabelProps={{ style: { fontSize: '0.7em' } }}
              label={t('formDetails.configChamados.LimiteFormulario')}
              onChange={(e) => {
                setLimitForm(Number(e.target.value));
              }}
              value={limitForm === 0 ? undefined : limitForm}
            />
            <FormControl sx={{ width: 250 }}>
              <InputLabel id="demo-simple-select-label">{t('formDetails.configChamados.Obrigatorio')}</InputLabel>
              <Select
                size='small'
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label={t('formDetails.configChamados.Obrigatorio')}
                onClick={() =>
                  trackEventMatomo('modal config form', 'click', 'select', 'seleciona status')}
                style={{ border: 'none', borderBottom: '1px solid black', width: '10px !important' }}
                onChange={(e) => {
                  setMandatoryForm(e.target.value === 'verdadeiro' ? true : false);
                }}
                value={!mandatoryForm ? 'falso' : 'verdadeiro'}
              >
                <MenuItem value={'verdadeiro'}>{t('yes')}</MenuItem>
                <MenuItem value={'falso'}>{t('no')}</MenuItem>
              </Select>
            </FormControl>
          </Stack>
          <Typography>
            {t('formDetails.configChamados.ChamadosSub-item')}
          </Typography>
          <Autocomplete
            fullWidth
            id="tags-standard"
            size='small'
            disableClearable
            loadingText='Carregando dados...'
            onClick={() => trackEventMatomo('modal config form', 'click', 'select', 'seleciona tipo de serviço')}
            isOptionEqualToValue={(option, value) => option.value === value.value}
            filterSelectedOptions
            getOptionLabel={(option) => option.label}
            options={
              form?.itens?.flatMap((item, indexItem) => {
                return (
                  item.subitens.map((sub, indexSubItem) => {
                    return {
                      value: `${indexItem}|${indexSubItem}`,
                      label: sub.nome
                    };
                  })
                );
              }) || []}
            groupBy={(option) => form.itens[Number(option.value.slice(0, -2))]?.nome as string}
            onChange={(event: any, newValue: any | null, reason: any, details: any) => {
              getSubItemFilled(newValue.value);
              handleForceupdateMethod();
              setSelectedSub(newValue.value);
            }}
            renderInput={(params) =>
              <TextField {...params}
                variant='outlined'
                label={t('formDetails.configChamados.SelecioneSubitem')}
              />}
          />
          {selectedSub &&
            <Stack
              width={'100%'}
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={1}
            >
              <Autocomplete
                fullWidth
                onClick={() =>
                  trackEventMatomo('modal config form', 'click', 'select', 'seleciona tipo de serviço')}
                renderTags={(tagValue, getTagProps) => {
                  return tagValue.map((option, index) => (
                    <Chip style={{ marginTop: '12px' }} {...getTagProps({ index })} label={option.label} />
                  ));
                }}
                size='small'
                multiple
                value={serviceTypesSub?.map((ele) => (
                  {
                    value: ele,
                    label: services.data?.find((elem: types) => elem.tipoId === ele)?.nome
                  }
                )) || []}
                isOptionEqualToValue={(option, value) => option.value === value.value}
                filterSelectedOptions
                disableClearable
                options={
                  services.data?.sort((a: types, b: types) => {
                    return a.nome.toLowerCase() > b.nome.toLowerCase() ? 1 : - 1;
                  })
                    ?.map((ele: types) => ({
                      label: ele.nome,
                      value: ele.tipoId,
                    })) || []}
                onChange={(event: any, newValue: { label: string, value: string }[] | null, reason: any, details: any) => {
                  const value = details?.option.value;
                  if (serviceTypesSub?.includes(value)) {
                    setServiceTypesSub(prev => prev ? prev.filter(el => el !== value) : []);
                  } else {
                    setServiceTypesSub((prev) => prev ? [...prev, value] : [value]);
                  }
                }}
                renderOption={(props, option, { selected }) => (
                  <li {...props} key={option.value}>
                    <span>{option.label}</span>
                  </li>)}
                renderInput={(params) => <TextField {...params} InputLabelProps={{ style: { fontSize: '0.7em' } }} label={t('formDetails.configChamados.SelecioneOTiposubitem')} />}
              />
              <TextField
                size='small'
                onClick={() =>
                  trackEventMatomo('modal config form', 'click', 'input', 'adiciona valor de limite')}
                InputLabelProps={{ style: { fontSize: '0.7em' } }}
                label={t('formDetails.configChamados.LimiteSubitem')}
                onChange={(e) => {
                  setLimitSub(Number(e.target.value));
                }}
                value={limitSub === 0 ? undefined : limitSub}
              />
              <FormControl sx={{ width: 250 }}>
                <InputLabel id="demo-simple-select-label"> {t('formDetails.configChamados.Obrigatorio')}</InputLabel>
                {!subitemType(selectedSub) ? <Select
                  size='small'
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label={t('formDetails.configChamados.Obrigatorio')}
                  onClick={() => trackEventMatomo('modal config form', 'click', 'select', 'seleciona mandatorio')}
                  onChange={(e) => {
                    setMandatorySub(e.target.value as mandatorySub);
                  }}
                  value={mandatorySub || 'naoConforme'}
                >
                  <MenuItem value={'naoConforme'}>{t('checklists.formModal.nonConformity')}</MenuItem>
                  <MenuItem value={'conforme'}>{t('checklists.formModal.conformity')}</MenuItem>
                  <MenuItem value={'sempre'}>{t('checklists.formModal.always')}</MenuItem>
                  <MenuItem value={'nunca'}>{t('checklists.formModal.never')}</MenuItem>
                </Select>
                  : <Select
                    size='small'
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label={t('formDetails.configChamados.Obrigatorio')}
                    onClick={() => trackEventMatomo('modal config form', 'click', 'select', 'seleciona mandatorio')}
                    onChange={(e) => {
                      setMandatorySub(e.target.value as mandatorySub);
                    }}
                    value={mandatorySub || 'naoConforme'}
                  >
                    <MenuItem value={'sempre'}>{t('checklists.formModal.always')}</MenuItem>
                    <MenuItem value={'nunca'}>{t('checklists.formModal.never')}</MenuItem>
                  </Select>}
              </FormControl>
            </Stack>
          }
        </Stack>}
    </>
  );
}